// extracted by mini-css-extract-plugin
export default {"qr":"qr_login_qr__7qzcX","qrImage":"qr_login_qrImage__WtPvz","tip":"qr_login_tip__Z1j7M","confirm":"qr_login_confirm__x0ku5"};